import { useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { PartnerAuthState } from 'stores/PartnerAuthStore';
import {
  ServiceStatusState,
  ServiceStatusAction,
} from 'stores/ServiceStatusStore';
import { apiGetServiceStatus } from 'api/ZimssaAPI';

function getServiceType(serviceType?: string): string {
    switch (serviceType) {
        case 'smallmove':
        case 'small_move':
            return 'smallmove';
        case 'familymove':
        case 'family_move':
            return 'familymove';
        case 'movecleaning':
        case 'move_cleaning':
            return 'move_cleaning';
        default:
            return '';
    }
}

const useServiceStatus = () => {
  const dispatcher = useContext(ServiceStatusAction);
  const serviceState = useContext(ServiceStatusState);
  const { service } = useContext(PartnerAuthState);
  const { serviceType, serviceIdx } = useParams<{ serviceType: string, serviceIdx: string }>();
  const serviceByType = service.find(
    (item) => item.serviceIdx === Number(serviceIdx)
  ) || {
    serviceIdx: 0,
    serviceType: '',
    serviceDocStatus: '',
    serviceActiveStatus: '',
  };
  useEffect(() => {
    if (serviceType && Number(serviceIdx) !== 0) {
      apiGetServiceStatus(getServiceType(serviceType), Number(serviceIdx))
        .then((response) => {
          const { result, data } = response;

          if (result === 'success') {
            dispatcher({
              type: 'SET_STATE',
              value: data,
            });
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  }, [dispatcher, serviceIdx, serviceType]);
  /**
   * TODO : move_cleaning 부분만 따로 _있는 상태로 유지하는 부분 수정
   */
  return {
    serviceIdx: serviceByType.serviceIdx,
    serviceType:
      serviceByType.serviceType !== 'move_cleaning'
        ? serviceByType.serviceType.replace('_', '')
        : serviceByType.serviceType,
    serviceDocStatus: serviceByType.serviceDocStatus,
    serviceActiveStatus: serviceByType.serviceActiveStatus,
    serviceState,
  };
};

export default useServiceStatus;
